/* eslint-disable no-console */
import Swal from "sweetalert2";
import { getReasonPhrase } from 'http-status-codes';

export const mixin = {

  created: function () {
    // console.log('Mixin Hook Started!')
  },

  methods: {
    alertSuccess: function (text = '', timer = 1500) {
      return Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: text ? text : 'Your work has been saved',
        showConfirmButton: false,
        timer: timer
      })
    },

    // eslint-disable-next-line no-unused-vars
    alertError: function (text = '', status = null) {
      return !status ? Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: text ? text : 'システムエラー、もう一度やり直してください。!',
      }) : Swal.fire({
        icon: 'error',
        title: status ? status : 'Oops...',
        text: status ? getReasonPhrase(status) : 'システムエラー、もう一度やり直してください。!',
      })
    },

    progressBar: function () {
      // let timerInterval
      Swal.fire({
        title: 'ダウンロード中です。少々お待ちください。',
        position: 'top-end',
        html: '<div class="spinner-border text-success" role="status">' +
          '  <span class="sr-only">Loading...</span>' +
          '</div>',
        timerProgressBar: true,
        showConfirmButton: false,
      })

    },

    uploadVideoMixin: function () {
      // let timerInterval
      Swal.fire({
        title: 'アップロード中です。少々お待ちください。',
        position: 'top-end',
        html: '<div class="spinner-border text-success" role="status">' +
          '  <span class="sr-only">Loading...</span>' +
          '</div>',
        timerProgressBar: true,
        showConfirmButton: false,
        allowOutsideClick: false,
      });
    },

    alertSuccessTop: function (text = '') {
      return Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: text ? text : 'Your work has been saved',
        showConfirmButton: false,
        timer: 1500
      })
    },

    confirm: (options, callback) => {
      Swal.fire(options).then((result) => {
        callback(result);
      });
    },

    /**
     *
     * @param {string|number|null|undefined} genderCode
     * @returns {string}
     */
    genderName(genderCode) {
      switch (genderCode) {
        case '':
        case null:
        case undefined:
          return '';
        case 0:
          return '女性';
        case 1:
          return '男性';
        default:
          return '無回答';
      }
    },
  }
}
